export const QueryParamsKeys = {
    tab_key: 'tab_key',
};
